import React from 'react';

class DeliverToBranch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addresses: this.props.addresses,
      search_postcode: '',
      postcode_valid: false,
      locationSearch: false,
      search_postcode_error: false,

      newAddress: {
        name: '',
        line_1: '',
        line_2: '',
        line_3: '',
        line_4: '',
        line_5: '',
        postcode: '',
      },
      newAddressValid: false,
      guestTelephoneError: false,
    };

    this.setDeliveryAddress = this.setDeliveryAddress.bind(this);

    this.handleSearchPostCodeChange =
      this.handleSearchPostCodeChange.bind(this);
    this.validateNewAddressInput = this.validateNewAddressInput.bind(this);
  }

  componentWillReceiveProps(props) {
    this.setState({ addresses: props.addresses });
  }

  setDeliveryAddress(address) {
    if (this.props.signed_in === false) {
      if (this.props.guestTelephone) {
        this.props.handleTelephoneError(false);
        this.props.setAddressFromAddressBook(address);
        this.props.setBranchAddressFlag(true);
      } else {
        this.props.handleTelephoneError(true);
      }
    } else {
      this.props.setAddressFromAddressBook(address);
      this.props.setBranchAddressFlag(true);
    }
  }

  validateNewAddressInput() {
    if (
      this.state.newAddress.name !== '' &&
      this.state.newAddress.line1 !== '' &&
      this.state.newAddress.line3 !== '' &&
      this.props.valid_postcode(this.state.newAddress.postcode).isValid === true
    ) {
      this.setState({ newAddressValid: true });
    } else {
      this.setState({ newAddressValid: false });
    }
  }

  handleSearchPostCodeChange(e) {
    this.setState({
      search_postcode: e.target.value,
      search_postcode_error: false,
    });

    this.props.valid_postcode(e.target.value).isValid === true
      ? this.setState({ postcode_valid: true, locationSearch: false })
      : this.setState({ postcode_valid: false, locationSearch: true });
    if (e.target.value === '') {
      this.setState({ addresses: [] });
    }
  }

  render() {
    var addresses =
      this.state.addresses.length > 0 ? (
        this.state.addresses.map((address, index) => {
          var selected =
            _.isEqual(
              {
                line1: address.line_1,
                line2: address.line_2,
                line3: address.line_3,
                line4: address.line_4,
                line5: address.line_5,
                postcode: address.postcode,
                name: address.name,
              },
              this.props.selectedDeliveryAddress,
            ) === true
              ? 'selected'
              : '';

          return (
            <div
              className={'address-book-address ' + selected}
              key={index}
              onClick={this.setDeliveryAddress.bind(this, address)}>
              <ul key={index}>
                <li className="address-name">
                  <strong>{address.name}</strong>
                </li>
                <li>{address.line_1}</li>
                <li>{address.line_2}</li>
                <li>{address.line_3}</li>
                <li>{address.postcode}</li>
              </ul>
              <div className="actions">
                {selected ? (
                  <div>
                    <span className="selected-icon" /> Selected
                  </div>
                ) : (
                  <div>
                    <span className="selected-icon" /> Select
                  </div>
                )}
              </div>
            </div>
          );
        })
      ) : (
        <p>No Addresses Found</p>
      );

    var addressPanel = null;
    if (this.state.addresses.length > 0 && this.props.showBranchPanel) {
      addressPanel = <div className="address-book">{addresses}</div>;
    }

    var loading =
      this.state.loading === true ? (
        <span className="loading">
          <i className="icon-spinner icon-spin icon-large" />
        </span>
      ) : (
        ''
      );
    var postcodeSearchError =
      this.state.search_postcode_error === true ? (
        <span className="search-postcode--error">
          No Addresses found for postcode
        </span>
      ) : (
        ''
      );
    return (
      <div
        className={
          'checkout-sub-panel branch-address ' +
          (this.props.addressMode !== 'BRANCH_DELIVERY' ? 'hide' : '')
        }>
        <div className="ip-top-border ip-top-padding">
          <div className="fl-on fl-jc-sb input-address">
            <div className="fl-fb-50-tab fl-fb-30">
              <h2>Search for a Store</h2>
              <label>
                Search by town or postcode{' '}
                <strong className="required">*</strong>
              </label>
              <input
                type="text"
                value={this.state.search_postcode}
                onChange={this.handleSearchPostCodeChange}
                autoComplete="no"
                data-testid={
                  this.props.signed_in === false
                    ? 'guest-store-postcode-input'
                    : 'account-store-postcode-input'
                }
              />
              <button
                onClick={this.props.getBranches.bind(
                  this,
                  this.state.search_postcode,
                  this.state.locationSearch,
                )}
                disabled={this.state.search_postcode === ''}
                data-testid={
                  this.props.signed_in === false
                    ? 'guest-find-store-address'
                    : 'account-find-store-address'
                }>
                Find Address
              </button>
              {postcodeSearchError}
              {loading}
            </div>
            {this.props.signed_in === true && (
              <div className="fl-fb-50 setCurrentBranch">
                <h2>Deliver to {this.props.branchAddress.name}</h2>
                <ul>
                  <li>
                    <strong>{this.props.branchAddress.name}</strong>
                  </li>
                  <li>{this.props.branchAddress.line_1}</li>
                  <li>{this.props.branchAddress.line_2}</li>
                  <li>{this.props.branchAddress.line_3}</li>
                  <li>{this.props.branchAddress.postcode}</li>
                </ul>
                <button
                  className="grey-button"
                  data-testid={
                    this.props.signed_in === false
                      ? 'guest-select-store-address'
                      : 'account-select-store-address'
                  }
                  onClick={this.setDeliveryAddress.bind(
                    this,
                    this.props.branchAddress,
                  )}>
                  Select Store
                </button>
              </div>
            )}
          </div>
          {addressPanel}
          {this.props.showNoBranches && (
            <p className="search-postcode--error">No Stores Found</p>
          )}
        </div>
      </div>
    );
  }
}

export default DeliverToBranch;
